import React from 'react';
import styled from 'styled-components';
import { Switch as AntdSwitch } from 'antd';
import { SwitchProps as AntdSwitchProps } from 'antd/lib/switch';
import { buildCssProp } from 'utils';
import theme from '../theme';
import LabelWrapper from '../LabelWrapper';

export type SwitchProps = AntdSwitchProps & {
  label?: string;
  required?: boolean;
  addonAfter?: React.ReactNode;
};

/** @deprecated use Switch from @bb/elements-web instead */
export const Switch: React.FC<SwitchProps> = ({
  label,
  required,
  addonAfter,
  className,
  ...props
}) => (
  <LabelWrapper
    label={label}
    error={false}
    required={required}
    className={className}
  >
    <StyledWrapper>
      <StyledSwitch {...props} />
      {addonAfter && <div onClick={e => e.stopPropagation()}>{addonAfter}</div>}
    </StyledWrapper>
  </LabelWrapper>
);

const StyledWrapper = styled.div`
  display: flex;
  > * {
    margin-right: 8px;
  }
`;

const StyledSwitch = styled(AntdSwitch)`
  ${({ disabled }) =>
    buildCssProp(
      'background-color',
      disabled && theme.getColor('disabledColor'),
    )}
`;

export default Switch;
